<template>
    <div class="options">
        <div class="option" v-for="(option, index) in options" :key="index">
            <!-- Passing in the whole object on *value* so I can access different properties on parent component -->
            <input
                class="radio"
                type="radio"
                v-model="selectedOption"
                :name="option[valueKey]"
                :id="_uid + '' + index"
                :value="option[idKey]"
                @change="setChoice"
            />
            <label :for="_uid + '' + index">
                <span class="option-value">{{ option[valueKey] }}</span>
                <span class="option-price" v-if="showPrices">+ £{{ NumberFormat(option[priceKey], 0) }}</span>
            </label>

            <div v-if="hasInfo" class="option-info" @click="defineInfoAndOpenModal(option)">i</div>
        </div>
    </div>
</template>

<script>
import NumberFormat from '../../used-vue/api/NumberFormat';

export default {
    props: {
        value: {
            default: null
        },
        idKey: {
            required: true
        },
        valueKey: {
            required: true
        },
        priceKey: {
            default: null,
            required: false
        },
        showPrices: {
            default: false,
            required: false
        },
        options: {
            type: [Array, Object],
            required: true
        },
        hasInfo: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    watch: {
        value(newValue) {
            this.selectedOption = newValue;
        }
    },
    data() {
        return {
            selectedOption: this.value,
            isModalVisible: false
        }
    },
    methods: {
        NumberFormat,
        setChoice: function () {
            this.$emit('input', this.selectedOption)
        },
        defineInfoAndOpenModal: function (option) {
            this.$emit('info-clicked', option);
            // this.optionInfo = option;

            // if (previousOption) {
            //     this.optionInfo['previousOption'] = previousOption.value;
            // }

            // this.isModalVisible = true;
        },
        // closeModal: function () {
        //     this.isModalVisible = false;
        // }
    }
}
</script>

<style lang="scss" scoped>
.options {
    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }

    @media (min-width: 768px) and (max-width: 991px) {
        display: grid;
        grid-auto-flow: column;
        column-gap: 30px;
        overflow-x: auto;
        padding: 0 0 15px 0;
    }

    @media (min-width: 992px) {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }

    label {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 16px;
        justify-content: space-between;
        color: #0093D6;
        font-size: 16px;
        font-weight: 600;

        @media (min-width: 768px) and (max-width: 991px) {
            height: 100%;
        }
    }
}

.option {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    user-select: none;

    @media (min-width: 768px) and (max-width: 991px) {
        min-width: 250px;
    }

    &-value {
        flex-shrink: 1;
    }

    &-price {
        flex-shrink: 0;
    }

    &-info {
        width: 29px;
        height: 29px;
        border-radius: 23px;
        background-color: rgba(155, 155, 155, .15);
        font-size: 16px;
        color: #0093D6;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
    }
}

.radio {
    display: none;
}

.radio + label {
    width: 100%;
    padding: 13px 10px;
    border-radius: 6px;
    border: 1px solid #0093D6;
    cursor: pointer;
    transition: 0.3s;
    flex-shrink: 1;

    &:hover {
        background-color: #0093D6;
        color: #FFF;
    }
}

.radio:checked + label {
    background-color: #0093D6;
    color: #FFF;
}
</style>